import type { StorageAdapter } from '@/services/storage/storage-adapter';
import type { Property, CreatePropertyInput, UpdatePropertyInput } from '@/types/property';
import { recordPendingDelete } from './sync-service';
import { posthogService } from '@/services/posthog-service';
import { EVENT_PROPERTY_CREATED } from '@/services/observability/events';

export class PropertyService {
  constructor(private adapter: StorageAdapter) {}

  async getProperties(): Promise<Property[]> {
    return this.adapter.getProperties();
  }

  async getProperty(id: string): Promise<Property | null> {
    return this.adapter.getProperty(id);
  }

  async createProperty(data: CreatePropertyInput): Promise<Property> {
    const property = await this.adapter.createProperty(data);
    posthogService.track(EVENT_PROPERTY_CREATED);
    return property;
  }

  async updateProperty(id: string, data: UpdatePropertyInput): Promise<Property> {
    return this.adapter.updateProperty(id, data);
  }

  async deleteProperty(id: string): Promise<void> {
    await this.adapter.deleteProperty(id);
    await recordPendingDelete(id, 'property');
  }
}
